import { type FormEvent, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { loginAdmin } from '../api/auth'
import { MavolyraLogo } from '../components/MavolyraLogo'
import { Button } from '../components/ui'
import type { AuthState } from '../types/auth'
import styles from './LoginPage.module.css'

type LoginPageProps = {
  auth: AuthState
  onAuthenticated: (state: AuthState) => void
}

export const LoginPage = ({ auth, onAuthenticated }: LoginPageProps) => {
  const navigate = useNavigate()
  const [email, setEmail] = useState(import.meta.env.DEV ? 'admin@mavolyra.local' : '')
  const [password, setPassword] = useState(import.meta.env.DEV ? 'change-me-now' : '')
  const [pending, setPending] = useState(false)

  const handleSubmit = async (event: FormEvent<HTMLFormElement>): Promise<void> => {
    event.preventDefault()
    setPending(true)

    try {
      const user = await loginAdmin({ email, password })
      onAuthenticated({ state: 'authenticated', user })
      navigate('/admin/channels', { replace: true })
    } catch (error) {
      onAuthenticated({
        state: 'error',
        message: error instanceof Error ? error.message : 'Unknown error'
      })
    } finally {
      setPending(false)
    }
  }

  return (
    <main className={styles.shell}>
      <form className={styles.panel} onSubmit={(event) => void handleSubmit(event)}>
        <MavolyraLogo className={['brand-logo', styles.logo].join(' ')} showAdminLabel />
        <h1>Mavolyra Admin</h1>
        {auth.state === 'error' && <div className={styles.errorNotice}>{auth.message}</div>}
        <label className="form-group">
          <span className="form-label">Email</span>
          <input className="form-input" onChange={(event) => setEmail(event.target.value)} type="email" value={email} />
        </label>
        <label className="form-group">
          <span className="form-label">Password</span>
          <input className="form-input" onChange={(event) => setPassword(event.target.value)} type="password" value={password} />
        </label>
        <Button disabled={pending} type="submit" variant="primary">
          {pending ? 'Signing in...' : 'Sign in'}
        </Button>
      </form>
    </main>
  )
}
